import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { ThreadFiltersMenuButton }
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu';
import HouseholdSelect from 'Components/ComponentLibrary/Components/Uncategorized/HouseholdSelect';
import {
  useThreadList,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadList/useThreadList';
import { DataValueMap } from 'Helpers/Testing';
import { FDBox, FDStack } from '@facet-wealth/design';
import FDChip from 'Packages/FacetDesign/Components/Experimental/FDChip';
import {
  SELECTABLE_FILTER_FIELD_NAMES,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const AgentThreadListFilters = ({
  handleToggle,
  debouncedOnSubmit,
  numberOfSelectedFilters,
}) => {
  const {
    isSearching, threadsCollection,
  } = useMessagesContext();
  const { resource } = useMetaLayoutContext();

  const {
    handleHouseholdSelect,
    beforeHandleHouseholdSelect,
  } = useThreadList();

  const attributes = resource.attributes();
  const attributesArray = Object.keys(attributes);
  const selectedFilters = attributesArray.filter((attribute) => {
    if (SELECTABLE_FILTER_FIELD_NAMES.includes(resource.meta().field(attribute).attr('name'))) {
      return resource.attr(attribute);
    }
    return false;
  });

  const getPromptForSelectedFilter = (attr) => {
    const queryParamOptions = resource.meta().field(attr).options();
    // Return metaField prompt if query param is not a picklist
    if (!queryParamOptions || queryParamOptions.list().length === 0) {
      return resource.meta().field(attr).attr('prompt');
    }

    // Return selected picklist item prompt if query param is a picklist
    return queryParamOptions.findItem(i => i.id() === resource.attr(attr))?.attr('prompt');
  };

  return (
    <FDStack direction={'column'} spacing={2} paddingY={1}>
      <HouseholdSelect
        collection={threadsCollection}
        beforeSubmit={(householdId) => beforeHandleHouseholdSelect(householdId)}
        onSubmit={(resultCollection, householdId) => handleHouseholdSelect(resultCollection, householdId)}
        disabled={isSearching}
      />
      <FDStack direction={'column'} spacing={1} alignItems={'flex-start'} alignSelf={'flex-start'}>
        <FDStack direction={'row'} spacing={1} alignItems={'center'} width={'100%'} wrap>
          <FDBox {...DataValueMap.init('message-page-search').build()}>
            <MetaControlField
              key={'search'}
              attr={'search'}
              resource={resource}
              onSearch={(value) => debouncedOnSubmit(value)}
              disabled={isSearching}
            />
          </FDBox>
          <ThreadFiltersMenuButton
            onChange={(value, attr) => handleToggle(value, attr)}
            numberOfSelectedFilters={numberOfSelectedFilters}
          />
        </FDStack>
        <FDStack direction={'row'} spacing={1} wrap>
          {selectedFilters.map((attr) => {
            const label = getPromptForSelectedFilter(attr);
            return (<FDChip label={label} onDelete={() => handleToggle(null, attr)} test={`${attr}-chip`} />);
          })
          }
        </FDStack>
      </FDStack>
    </FDStack>
  );
};

AgentThreadListFilters.defaultProps = {
  className: '',
};

AgentThreadListFilters.propTypes = {
  className: PropTypes.string,
  handleToggle: PropTypes.func.isRequired,
  debouncedOnSubmit: PropTypes.func.isRequired,
  numberOfSelectedFilters: PropTypes.number.isRequired,
};

export { AgentThreadListFilters };
